<template>
  <div v-if="error">
    <!-- add icon here and remove -->
    <p class="error-message">{{ message }}</p>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default: 'Invalid Field',
    },
    error: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.error-message {
  color: red;
  font-size: 12px;
  margin-bottom: 0px;
}
</style>
